import React, {useContext} from 'react';
import "../assets/scss/Static.scss";
import {AlertContext} from "../store/use_context";
import {FormHeader} from "./FormHeader";
import Grid from "@material-ui/core/Grid";
import {not_validate_value} from "../App";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {CustomModal} from "./CustomModal";

export const CustomAlertModal = props => {
    const {alert_msg, setAlert} = useContext(AlertContext);

    const handleClose = () => {
        setAlert("");
    };

    return (
            <CustomModal
                open={!not_validate_value.includes(alert_msg)}
            >
                    <Grid container  spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6" className='p-1' style={{whiteSpace: 'pre-line'}}>
                            {alert_msg}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} className='text-right'>
                        <Button
                            onClick={handleClose}
                            variant="contained"
                            color='primary'
                            size="medium"
                        >
                            Ok
                        </Button>
                    </Grid>
                    </Grid>
            </CustomModal>
    );
}
